import React, { useState } from 'react';
import styles from 'feature/receipt/index.module.sass';
import loveCodeData from 'json/love_code';
import { useReceiptContext, CHANGE_PAYLOAD } from 'feature/receipt/use-receipt';
import iconCheck from 'assets/icon_check_blue.svg';
import classnames from 'classnames/bind';
import arrow from 'assets/arrow.svg';
import { useHistory } from 'react-router-dom';
import { PATH } from 'config';
const cx = classnames.bind(styles);

const LoveCodeItem = ({ item, isChecked, onClick }) => {
  const itemClass = cx({
    'donate-item': true,
    check: isChecked,
  });

  return (
    <div className={itemClass} onClick={onClick}>
      <div className={styles.content}>
        <div className={styles.code}>愛心碼 {item.love_code}</div>
        <div className={styles.name}>{item.name}</div>
      </div>
      <div className={styles.icon}>
        <img src={iconCheck} alt="icon-check" />
      </div>
    </div>
  );
};

const setFilterLoveCodeData = (keyword = '') => {
  let filterData = [];
  if (keyword === '') {
    filterData = loveCodeData;
  } else {
    filterData = loveCodeData.filter(x => {
      return x.name.indexOf(keyword) !== -1 || x.love_code.indexOf(keyword) !== -1;
    });
  }
  return filterData;
};

const ReceiptDonate = () => {
  const { state, dispatch } = useReceiptContext();
  const [text, setText] = useState();
  const [filterLoveCodes, setFilterLoveCodes] = useState(setFilterLoveCodeData(''));
  const history = useHistory();

  const searchBarChange = event => {
    let searchInput = event.target.value;
    setText(searchInput);
    setFilterLoveCodes(setFilterLoveCodeData(searchInput));
  };

  const selectLoveCode = loveCode => {
    if (state.loveCode !== loveCode) {
      dispatch({ type: CHANGE_PAYLOAD, payload: { loveCode } });
    }
  };

  return (
    <div className={styles['donate-layout']}>
      <div className={styles['search-bar']}>
        <img
          src={arrow}
          alt="arrow"
          onClick={() => history.push({ pathname: PATH.RECEIPT_INDEX, state: { from: PATH.RECEIPT_DONATE } })}
        />
        <input
          className={styles['search-input']}
          type="text"
          value={text}
          onChange={searchBarChange}
          placeholder="搜尋愛心碼或社福團體名稱"
        />
      </div>
      <div className={styles['donate-list']}>
        {filterLoveCodes.map(code => {
          return (
            <LoveCodeItem
              key={code.love_code}
              item={code}
              isChecked={state.loveCode === code.love_code}
              onClick={() => selectLoveCode(code.love_code)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ReceiptDonate;
